import { IntlShape } from 'react-intl';

import { ClinicalAssessmentResult } from 'services/user';

export const getTranslatedResult = (
  result: ClinicalAssessmentResult,
  intl: IntlShape,
) => {
  const translations = {
    'lbl-none-minimal': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MINIMAL',
    }),
    'lbl-mild': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MILD',
    }),
    'lbl-moderate': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MODERATED',
    }),
    'lbl-moderately-severe': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MODERATELYSEVERE',
    }),
    'lbl-severe': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.SEVERE',
    }),
    'lbl-minimal-anxiety': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MINIMAL',
    }),
    'lbl-mild-anxiety': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MILD',
    }),
    'lbl-moderate-anxiety': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.MODERATED',
    }),
    'lbl-severe-anxiety': intl.formatMessage({
      id: 'ENDUSER.CLINICALASSESSMENT.SEVERE',
    }),
    'very-high': intl.formatMessage({
      id: 'CP.PLATFORM.WHO5.RESULTS.LABEL.VERY.HIGH',
    }),
    high: intl.formatMessage({
      id: 'CP.PLATFORM.WHO5.RESULTS.LABEL.HIGH',
    }),
    low: intl.formatMessage({
      id: 'CP.PLATFORM.WHO5.RESULTS.LABEL.LOW',
    }),
    'very-low': intl.formatMessage({
      id: 'CP.PLATFORM.WHO5.RESULTS.LABEL.VERY.LOW',
    }),
  };
  return translations[result];
};
